import { stReportSdk } from './report';

stReportSdk.trackPageLeave();
